import React, {useEffect, useRef, useState} from 'react';
import {HStack, Pressable, VStack} from "native-base";
import {Colors} from "../../styles/Colors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {GlobalConsts} from "../../styles/GlobalConsts";
import AppText from "./AppText";
import {GlobalStyleAttributes} from "../../styles/GlobalStyles";
import CustomButtonV2 from "./CustomButtonV2";
import InfoTooltip from './InfoTooltip';
import { useDispatch } from 'react-redux';
import { openLimitedPackageModal } from '../../services/Helpers';
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";

const FoldableSettingSection = (props) => {
    const { isOpen, onToggle, header, extraHeader, children, infoTooltip, hasLock, summary, error, errorIcon, headerProps, noGap, testID } = props;
    const dispatch = useDispatch();
    const contentRef = useRef(null);
    const [contentHeight, setContentHeight] = useState(0);

    useEffect(() => {
        if (contentRef.current) {
            const height = contentRef.current.scrollHeight;
            setContentHeight(height);
        }
    }, [children]);

    const contentStyle = {
        transition: 'max-height 0.3s ease-out',
        maxHeight: isOpen ? `${contentHeight}px` : '0',
        overflow: 'hidden',
        paddingBottom: isOpen ? '1px' : 0,
    };

    return (
        <VStack testID={testID} p={'1rem'} space={noGap ? '0' : '0.5rem'} borderWidth={1} borderColor={Colors.borderColor} borderRadius={4} opacity={hasLock ? 0.5 : 1}>
            <CustomButtonV2 onClick={hasLock ? () => openLimitedPackageModal(dispatch) : onToggle}
                            override={() => (
                                <HStack justifyContent={'space-between'} w={'100%'}>
                                    {header &&
                                    <HStack alignItems={'center'}>
                                        <AppText fontSize={GlobalStyleAttributes.fonts.heading3} boldFont {...(headerProps ?? {})}>{header}</AppText>
                                        {infoTooltip && <InfoTooltip title={infoTooltip}/>}
                                        {errorIcon && <div style={{margin: '0 5px'}}><FontAwesomeIcon color={Colors.warningIconColor} icon={solid('triangle-exclamation')} fontSize={GlobalConsts.iconSize.XS}/></div>}
                                    </HStack>}
                                    {extraHeader}
                                    {hasLock ? <FontAwesomeIcon icon={'fa-light fa-lock-keyhole'} fontSize={GlobalConsts.iconSize.XSS}/> :
                                    <div style={{transition: 'transform 0.3s ease-out', transform: isOpen ? 'rotate(-180deg)' : 'rotate(0deg)'}}>
                                        <FontAwesomeIcon icon={`fa-light fa-chevron-down`} fontSize={GlobalConsts.iconSize.XSS}/>
                                    </div>}
                                </HStack>)}
            />
            <div ref={contentRef} style={contentStyle}>
                {children}
            </div>
            {summary && <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.newDesign.darkGrey}>{summary}</AppText>}
            {error && <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{error}</AppText>}
        </VStack>
);
};

export default FoldableSettingSection;

